module.exports = __webpack_public_path__ + "3f3ef6c134ff41c0944c0d586f8eb43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-9.png
// module id = 313
// module chunks = 1